/**
 * CargaAryzta
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {CargaAryztaCollection} from '@/model/collection/CargaAryztaCollection'

/* TODO: review generated class */
export class CargaAryzta extends Resource {
  idcargaPk: number = 0

  dataCriacao: string | null = null

  cgcEmissorNf: string | null = null
  serieNotaFiscal: string | null = null
  danfe: string | null = null
  nrNotaFiscal: string | null = null
  siglaCliente: string | null = null
  cepCliente: string | null = null
  dataEmissaoNota: string | null = null
  dataSaidaMerc: string | null = null
  tipoFrete: string | null = null
  nomeTransp: string | null = null
  codigoCfop: string | null = null
  denominacaoCfop: string | null = null

  get $id() {
    return this.idcargaPk
  }
  set $id(val) {
    this.idcargaPk = val
  }

  /**
   * Gets a instance of a given ID of CargaAryzta
   */
  async getCargaAryzta(id: number) {
    return await Request.get(`/admin/carga-aryzta/${id}`)
      .name('getCargaAryzta')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of CargaAryzta
   */
  static async listCargaAryzta(params: any) {
    return await Request.get(`/admin/carga-aryzta`, {params})
      .name('listCargaAryzta')
      .as(CargaAryztaCollection)
      .getData()
  }

  /**
   * Persists a new instance of CargaAryzta. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistCargaAryzta() {
    return await Request.post(`/admin/carga-aryzta`, this)
      .name('persistCargaAryzta')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of CargaAryzta to use it in a CSV file
   */
  static async listCsvCargaAryzta(params: any) {
    return await Request.get(`/admin/carga-aryzta/csv`, {params})
      .name('listCsvCargaAryzta')
      .as(CargaAryztaCollection)
      .getData()
  }
}
